export const user = state => state.user



// WEBPACK FOOTER //
// ./src/store/getters.js